import { STOP_AUTHENTICATION } from '../constants/actionTypes';

const stopAuthentication = () => ({
    type: STOP_AUTHENTICATION,
  });

export default stopAuthentication;
